import { Modal, ModalWrapper } from "src/utils/fw"
import { useLocalStorage } from "src/utils/hooks"
import { useDateTime } from "../utils"

export const TimedPopup = ({id, firesAt, children}) => {
	const now = useDateTime()
	const [hasBeenDisplayed, setHasBeenDisplayed] = useLocalStorage(`timed-popup-${id}`)

	const shouldDisplay = (
		now > new Date(firesAt)  // Is after fire time
		&& now < new Date(firesAt)/1 + 1000*60*10 // Is within 10 minutes of activation
		&& !hasBeenDisplayed
	)

	return shouldDisplay
	  ? <Modal dismiss={() => setHasBeenDisplayed(true)}><ModalWrapper wrapperStyle={{padding: "40px", color: "white"}}>
			{children}
		</ModalWrapper></Modal>
		: null
}